import { useSearchParams } from "react-router-dom"

import { DateHelper } from "@/utils"
const useSalesSearchParams = () => {
  const [searchParams] = useSearchParams()
  const stringStartDate = DateHelper.subDays(7)
  const stringEndDate = DateHelper.currentDate()
  const startDate = new Date(
    DateHelper.formatToISO(stringStartDate)
  )
  const endDate = new Date(
    DateHelper.formatToISO(stringEndDate)
  )
  const params: TransactionsSearchParamsType = {
    page: Number(searchParams.get("page")) || 1,
    quantity: Number(searchParams.get("pageSize")) || 10,
    startDate:
      searchParams.get("startDate") || stringStartDate,
    endDate: searchParams.get("endDate") || stringEndDate,
    order_code: searchParams.get("order_code") || undefined,
    status: searchParams.get("status") || undefined,
    requestType:
      searchParams.get("requestType") || undefined,
    proposalNumber:
      searchParams.get("proposalNumber") || undefined,
    refetch: searchParams.get("refetch") || undefined,
  }
  return {
    params,
    startDate,
    endDate,
  }
}
export default useSalesSearchParams
